﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { DefaultGroupFormatter } from "../../Formatters/DefaultGroupFormatter";
import { HelideckStatusFormatter } from "../../Formatters/HelideckStatusFormatter";
import { LedStatusFormatter } from "../../Formatters/LedStatusFormatter";
import { WindVariationFormatter } from "../../Formatters/WindVariationFormatter";
import { WmoToMetarWeatherFormatter } from "../../Formatters/WmoToMetarWeatherFormatter";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { ParameterGroupInfoSet } from "../../ParameterGroupInfoSet";
import { ISiteObservationsPage } from "./ISiteObservationsPage";
import { LedBox } from "./LedBox";
import { ValueBox } from "./ValueBox";
import { WindCompass } from "./WindCompass";

export class Overview implements ISiteObservationsPage {

    public id: string = 'overview';
    public label: string = 'Overview';

    public station: ParameterSchemaStation;
    public warningGroup: WarningGroup;
    private windCompass: WindCompass; 

    public show(station: ParameterSchemaStation): boolean {
        if (station.Station.Region == 'GOM') {
            return false; //: GOM region special: we show GomDashboard instead.
        }

        let sensorCount = 0;

        for (let sensorId in station.Sensors) {
            sensorCount++;
        }
        return sensorCount != 0; // if no sensors we show the blank overview page
    }

    constructor(public mainSite: MainSite, private ctx: ILiveDataListenerContext) {
    }

    public notifyResize():void {
        this.windCompass.drawCompass();
    }

    public render(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation, warningGroup: WarningGroup): void {
        this.station = station;
        this.warningGroup = warningGroup;

        if (this.mainSite.basicViewSelectorBool) {
            this.renderBasic(container, listeners);
        } else {
            this.renderAdvanced(container, listeners);
        }
    }

    public renderAdvanced(container: JQuery, listeners: ILiveDataListener[]): void {

        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');

        var leftPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '28em')
            .css('width', '34em')
            .appendTo(page);
        
        let hasHeading = false;
        for (let sensorId in this.station.Sensors) {
            const sensor = this.station.Sensors[sensorId];

            for (let paramId in sensor.Parameters) {
                if (paramId.indexOf('Heading') != -1) {
                    hasHeading = true;                                         
                }
            }
        }

        let hasHelidecks = this.station.Helidecks.length > 0/* && !!(this.mainSite.hashData as any).hdstatus*/;

        let compassHeight = (hasHeading && hasHelidecks) ? 50 : (hasHeading || hasHelidecks) ? 75 : 100;

        listeners.push(
            this.windCompass = new WindCompass(this,
                leftPanel,
                0, 0, compassHeight, 62) // top, left, height, width, as %
        );

        if (hasHeading) {
            listeners.push(
                new ValueBox(this,
                    leftPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.Heading_deg),
                    compassHeight + 1, 0, 24, 62, this.ctx)
            );
        }

        if (hasHelidecks) {
            let boxWidth = (62 - (this.station.Helidecks.length - 1)) / this.station.Helidecks.length;

            var sortedHeliDecks = this.station.Helidecks.sort((a, b) => (a.Label > b.Label) ? 1 : -1);

            for (let i = 0; i < sortedHeliDecks.length; i++) {
                listeners.push(new ValueBox(this,
                    leftPanel,
                    new HelideckStatusFormatter(sortedHeliDecks[i]),
                    76, i * (boxWidth + 1), 24, 30, this.ctx));                                                                      
            }
        }

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.WindDirection_deg),
                0, 64, 24, 36, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new WindVariationFormatter(),
                25.33, 64, 24, 36, this.ctx, true, 2.1)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.WindSpeed_kts),
                50.67, 64, 24, 36, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.GustSpeed_kts),
                76, 64, 24, 36, this.ctx)
            );

        var rightPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '28em')
            .css('left', '35em')
            .css('width', '29em')
            .appendTo(page);

        var cloudContainer = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '74%')
            .css('width', '100%')
            .appendTo(rightPanel);

        if (this.station.Station.Id == "NorthSea_Nelson") {
            cloudContainer.css('height', '67%');
        }

        $('<div class="midi_SiteObservations_cloud_header">Cloud</div>').appendTo(cloudContainer);

        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 16%;">Layer 3</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 44%;">Layer 2</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 72%;">Layer 1</div>').appendTo(cloudContainer);

        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 24%;">Amount</div>').appendTo(cloudContainer);
        $(`<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 62%;">Height (${MainSite.getUnitConverter().getConvertedUnits(ParameterGroupInfoSet.First_CloudBaseHeight_ft.Units, ParameterGroupInfoSet.First_CloudBaseHeight_ft.Id)})</div>`).appendTo(cloudContainer);

        var cloudDataContainer = $('<div></div')
            .css('position', 'absolute')
            .css('top', '16%')
            .css('left', '24%')
            .css('height', '84%')
            .css('width', '76%')
            .appendTo(cloudContainer);

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Third_CloudCover),
                0, 0, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Second_CloudCover),
                33, 0, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudCover),
                66, 0, 34, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Third_CloudBaseHeight_ft),
                0, 50, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Second_CloudBaseHeight_ft),
                33, 50, 33, 50, this.ctx,
                false)
            );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudBaseHeight_ft),
                66, 50, 34, 50, this.ctx,
                false)
            );

        // vis and weather go in right panel, below cloud container
        let _t = 76,
            _h = 24;
        if (this.station.Station.Id == "NorthSea_Nelson") {
            _t = 68;
            _h = 22;
        }

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Visibility_m),
                _t, 0, _h, 40, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new WmoToMetarWeatherFormatter(),
                _t, 42, _h, 58, this.ctx)
            );

        if (this.station.Station.Id == "NorthSea_Nelson") {
            //: TEMPSC led:
            var fieldWrapLED = $('<div></div>')
                .css('position', 'absolute')
                .css('top', '90%')
                .css('left', '0')
                .css('height', '10%')
                .css('width', '100%')
                .css('padding', '12px 10px 8px')
                .appendTo(rightPanel);

            listeners.push(
                new LedBox(this,
                    fieldWrapLED,
                    new LedStatusFormatter(ParameterGroupInfoSet.TEMPSC_Status),
                    this.ctx)
            );
        }

        var bottomPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '19em')
            .css('left', '0em')
            .css('top', '29em')
            .css('width', '64em')
            .appendTo(page);

        if (this.station.Station.Id == "NorthSea_K14") {
            listeners.push(
                new ValueBox(
                    this,
                    bottomPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.QFE_mbar_HelideckC, 'Pressure'),
                    0, 0, 36, 19.2,
                    this.ctx,
                    true
                )
            );
            listeners.push(
                new ValueBox(
                    this,
                    bottomPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.QFE_mbar_HelideckP, 'Pressure (Helideck P)'),
                    0, 20.2, 36, 19.2,
                    this.ctx,
                    true

                )
            );

            listeners.push(
                new ValueBox(this,
                    bottomPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.AirTemperature_degC),
                    0, 40.4, 36, 19.2, this.ctx)
            );
        } else {
            if (this.station.Station.Id === "Victory"
                || this.station.Station.Id === "OrmenLange"
                || this.station.Station.Id === "Nyhamna") {
                listeners.push(
                    new ValueBox(
                        this,
                        bottomPanel,
                        new DefaultGroupFormatter(ParameterGroupInfoSet.WaterTemp_degC),
                        0, 0, 36, 19.2, this.ctx
                    )
                );
            } else {
                listeners.push(
                    new ValueBox(
                        this,
                        bottomPanel,
                        new DefaultGroupFormatter(ParameterGroupInfoSet.QFE_mbar),
                        0, 0, 36, 19.2, this.ctx
                    )
                );
            }

            listeners.push(
                new ValueBox(this,
                    bottomPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.AirTemperature_degC),
                    0, 20.2, 36, 19.2, this.ctx)
            );

            listeners.push(
                new ValueBox(this,
                    bottomPanel,
                    new DefaultGroupFormatter(ParameterGroupInfoSet.RelativeHumidity_pc),
                    0, 40.4, 36, 19.2, this.ctx)
            );
        }

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.QNH_mbar),
                39, 0, 36, 19.2, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.DewPoint_degC),
                39, 20.2, 36, 19.2, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.RainfallIntensity_mmphour),
                39, 40.4, 36, 19.2, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Hmax_m),
                0, 60.6, 36, 19.2, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Tp_s),
                39, 60.6, 36, 19.2, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Hs_m),
                0, 80.8, 36, 19.2, this.ctx)
            );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Tz_s),
                39, 80.8
                , 36, 19.2, this.ctx)
            );
        

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.METAR),
                78, 0, 20, 100, this.ctx,
                false,
                1.1)
            );

        page.appendTo(container);
    }

    public renderBasic(container: JQuery, listeners: ILiveDataListener[]): void {

        var page = $('<div class="midi_SiteObservations_padded_page_content"></div>');

        var leftPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '32em')
            .css('width', '34em')
            .appendTo(page);

        listeners.push(
            this.windCompass = new WindCompass(this,
                leftPanel,
                0, 0, 100, 62) // top, left, height, width, as %
        );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.WindDirection_deg),
                0, 64, 32, 36, this.ctx)
        );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.WindSpeed_kts),
                33.33, 64, 32, 36, this.ctx)
        );

        listeners.push(
            new ValueBox(this,
                leftPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.GustSpeed_kts),
                66.67, 64, 32, 36, this.ctx)
        );

        var rightPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '32em')
            .css('left', '35em')
            .css('width', '29em')
            .appendTo(page);

        var cloudContainer = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '74%')
            .css('width', '100%')
            .appendTo(rightPanel);

        $('<div class="midi_SiteObservations_cloud_header">Cloud</div>').appendTo(cloudContainer);

        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_layer" style="top: 16%;">Layer 1</div>').appendTo(cloudContainer);

        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 24%;">Amount</div>').appendTo(cloudContainer);
        $('<div class="midi_SiteObservations_cloud_header midi_SiteObservations_cloud_header_top_row" style="top: 0%; left: 62%;">Height (ft)</div>').appendTo(cloudContainer);

        var cloudDataContainer = $('<div></div')
            .css('position', 'absolute')
            .css('top', '16%')
            .css('left', '24%')
            .css('height', '84%')
            .css('width', '76%')
            .appendTo(cloudContainer);

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudCover),
                0, 0, 33, 50, this.ctx,
                false)
        );

        listeners.push(
            new ValueBox(this,
                cloudDataContainer,
                new DefaultGroupFormatter(ParameterGroupInfoSet.First_CloudBaseHeight_ft),
                0, 50, 33, 50, this.ctx,
                false)
        );

        listeners.push(
            new ValueBox(this,
                rightPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Visibility_m),
                33.33, 0, 32, 100, this.ctx)
        );

        listeners.push(
            new ValueBox(this, 
                rightPanel,
                new WmoToMetarWeatherFormatter(),
                66.67, 0, 32, 100, this.ctx)
        );

        var bottomPanel = $('<div></div>')
            .css('position', 'absolute')
            .css('height', '11em')
            .css('left', '0em')
            .css('top', '33em')
            .css('width', '64em')
            .appendTo(page);

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.QFE_mbar),
                0, 0, 100, 24, this.ctx)
        );


        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.QNH_mbar),
                0, 25.33, 100, 24, this.ctx)
        );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.AirTemperature_degC),
                0, 50.67, 100, 24, this.ctx)
        );

        listeners.push(
            new ValueBox(this,
                bottomPanel,
                new DefaultGroupFormatter(ParameterGroupInfoSet.Hs_m),
                0, 76, 100, 24, this.ctx)
        );

        page.appendTo(container);
    }
}